/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Companydetails_Incorporationdatelabel3Inputs */

const ja_company_companydetails_incorporationdatelabel3 = /** @type {(inputs: Company_Companydetails_Incorporationdatelabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`設立日`)
};

const en_company_companydetails_incorporationdatelabel3 = /** @type {(inputs: Company_Companydetails_Incorporationdatelabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date of Incorporation`)
};

/**
* | output |
* | --- |
* | "Date of Incorporation" |
*
* @param {Company_Companydetails_Incorporationdatelabel3Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const company_companydetails_incorporationdatelabel3 = /** @type {((inputs?: Company_Companydetails_Incorporationdatelabel3Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Companydetails_Incorporationdatelabel3Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_company_companydetails_incorporationdatelabel3(inputs)
	return en_company_companydetails_incorporationdatelabel3(inputs)
});
export { company_companydetails_incorporationdatelabel3 as "company_companyDetails_incorporationDateLabel" }